import {
  ADULT_UPPER_RIGHT, ADULT_UPPER_LEFT, ADULT_LOWER_RIGHT, ADULT_LOWER_LEFT,
  PEDO_UPPER_RIGHT, PEDO_UPPER_LEFT, PEDO_LOWER_RIGHT, PEDO_LOWER_LEFT,
} from './data.js'

export const ADULT_QUADRANTS = [ADULT_UPPER_RIGHT, ADULT_UPPER_LEFT, ADULT_LOWER_RIGHT, ADULT_LOWER_LEFT]
export const PEDO_QUADRANTS  = [PEDO_UPPER_RIGHT, PEDO_UPPER_LEFT, PEDO_LOWER_RIGHT, PEDO_LOWER_LEFT]

/**
 * Generic read-style odontogram in the dentist's view (patient's right on the
 * chart's left). The caller supplies `renderCell(toothNumber)` so the same
 * layout backs both the count-badge (treatment) and abbreviation-mark (oral
 * exam) variants.
 */
export function Odontogram({ quadrants, label, renderCell }) {
  const [ur, ul, lr, ll] = quadrants
  return (
    <div className="inline-block min-w-max">
      {label && <div className="text-[11.5px] uppercase tracking-[0.14em] font-semibold text-slate-400 mb-2">{label}</div>}
      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-slate-400 font-semibold mb-1.5 px-1">
        <span>Upper Right</span><span>Upper Left</span>
      </div>
      <ToothRow left={ur} right={ul} renderCell={renderCell} />
      <div className="my-1.5 border-t border-dashed border-slate-200" />
      <ToothRow left={lr} right={ll} renderCell={renderCell} />
      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-slate-400 font-semibold mt-1.5 px-1">
        <span>Lower Right</span><span>Lower Left</span>
      </div>
    </div>
  )
}

function ToothRow({ left, right, renderCell }) {
  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center gap-1">{left.map((n) => renderCell(n))}</div>
      <div className="w-px h-9 bg-slate-200 mx-0.5" />
      <div className="flex items-center gap-1">{right.map((n) => renderCell(n))}</div>
    </div>
  )
}
